export default __webpack_public_path__ + "static/media/rackspace-mail.bfe323cc.svg";